export default __webpack_public_path__ + "static/media/gallery-wip-emitter_03.4d250c0f.jpg";